import React from 'react';
import {connect} from 'react-redux';

import Grid from '@mui/material/Grid';

import {Dispatch, Store} from 'spectra-logic-ui';
import Card from 'spectra-logic-ui/components/card';

import {fetchPublicKeys} from '../common/fetch';
import ButtonToolbar from '../common/button_toolbar';
import {PublicKey} from '../common/types';
import Table from '../common/table';
import NewPublicKeyDialog from './new';
import isEmpty from 'is-empty';
import DeleteDialog from '../common/delete_dialog';

type Props = {
  items?: PublicKey[];
  error?: boolean;
  fetching?: boolean;
  fetchItems?: () => Promise<any>;
}

const PublicKeys = ({
  items = [],
  error = false,
  fetching = false,
  fetchItems,
}: Props) => {
  const [selectedItem, setSelectedItem] = React.useState({} as PublicKey);
  const clearItem = () => {
    setSelectedItem({} as PublicKey);
  };
  React.useEffect(() => {
    if (fetchItems !== undefined) {
      fetchItems();
    }
  }, []);
  return (
    <React.Fragment>
      <Grid container>
        <Grid item xs={12}>
          <Card>
            <Card.Body>
              <ButtonToolbar>
                <ButtonToolbar.CreateDialogButton dialog={NewPublicKeyDialog} />
                <ButtonToolbar.DeleteDialogButton
                  disabled={isEmpty(selectedItem)} onSuccess={clearItem}
                  dialog={(props: any) => (
                    <DeleteDialog
                      id={selectedItem.id} name={selectedItem.id} resource='public_key' {...props}
                    />
                  )}
                />
              </ButtonToolbar>
              <Table>
                <Table.Header>
                  <Table.Row>
                    <Table.Cell>ID</Table.Cell>
                    <Table.Cell>Value</Table.Cell>
                  </Table.Row>
                </Table.Header>
                <Table.Body isLoading={fetching} hasError={error}>
                  {items && items.map((item) => (
                    <Table.Row
                      key={item.id} selected={item.id === selectedItem.id}
                      onClick={() => setSelectedItem(item)}
                    >
                      <Table.Cell>{item.id}</Table.Cell>
                      <Table.Cell>{item.value}</Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </Card.Body>
          </Card>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

const mapStateToProps = (state: Store) => {
  const items = state.resources['public_key'] || {};
  return {
    items: items.data || [],
    error: items.error,
    fetching: items.fetching,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return ({
    fetchItems: () => fetchPublicKeys(dispatch),
  });
};

export default connect(mapStateToProps, mapDispatchToProps)(PublicKeys);
